import { INDRAPrice } from "@ibe.models/booking.fare.indra.model.lib";

/**
 * State for the miles bar component
 *
 * @export
 * @class State
 */
export class State {
	height: number;
	discount: number;
	discountInformationMiles: INDRAPrice;
}

export const initialState: State = {
	height: null,
	discount: 0,
	discountInformationMiles: {cash: 0, miles: 0}
};
